/**
 * @file Defines H1 style
 */

import styled, { css } from 'styled-components';

let fontMax = 64;
let fontMin = 48;

const H1 = styled.h1`
  font-family: ${({ font }) => font ? font : 'SFSemiBold'};
  font-size: calc(${fontMin}px + (${fontMax} - ${fontMin}) * ((100vw - 320px) / (1920 - 320)));	
  text-align: ${({ align }) => align ? align : 'left'};
  line-height: ${({ height }) => height ? height : '72'}px;
  color: ${({ color }) => color ? color : '#373737'};
  transition: all 0.5s ease;

  ${({ maxWidth }) => maxWidth && css`
    max-width: ${maxWidth};
  `}

  strong{
    color: #E3000F;
  }
  @media screen and (min-width: 1920px) {
    font-size: ${fontMax}px;
  }
`;

export default H1;